import { render } from "./index.vue?vue&type=template&id=f7771dbc&scoped=true"
import script from "./footer-bar.js?vue&type=script&lang=js"
export * from "./footer-bar.js?vue&type=script&lang=js"

import "./footer-bar.scss?vue&type=style&index=0&id=f7771dbc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7771dbc"]])

export default __exports__